import { useLazyQuery, useMutation } from '@apollo/client';
import { Box } from '@material-ui/core';
import CustomeDatePicker from 'component/customer_date_picker/custome_date_picker';
import CustomizeLayoutQuiz from 'component/layout_quiz/layout_quiz';
import { useAuth } from 'contexts/AuthContext';
import dayjs, { Dayjs } from 'dayjs';
import { CREATE_ANSWER } from 'graph_ql/getQuiz/mutation';
import { GET_QUIZ_RESPONSE } from 'graph_ql/getQuiz/queries';
import { GET_USER_BY_USERNAME } from 'graph_ql/users/queries';
import { useSpinnerLoading } from 'hooks/useSpinnerLoading';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { setMyBirthday } from 'redux/authentication/user_detail';
import { PATH } from 'routes/constant';
import { EQuestionId, EQuizId, quizContextType } from 'types/quiz';
import { useGetGender } from '../../../hooks/useGetGender';

export interface IMyBirthDayQuizProps {}

export default function MyBirthDayQuiz(props: IMyBirthDayQuizProps) {
    const { userName } = useParams<{ userName: string }>();
    const { currentUser } = useAuth();
    const history = useHistory();
    const gender = useGetGender(Boolean(userName));
    const location = useLocation();
    const dispatch = useDispatch();
    const [quizData, setQuizData] = useState<any>(null);
    const [value, setValue] = useState<Dayjs | null>(null);
    const [requiredQuestion, setRequiredQuestion] = useState(true);
    const [error, setError] = useState<string | null>('');

    const [getQuizResponse, { loading: loadingQuiz }] = useLazyQuery(GET_QUIZ_RESPONSE, {
        // fetchPolicy: 'network-only',
        onCompleted(data) {
            setRequiredQuestion(data.getQuizResponse?.questionsInfo[0]?.required);
            setQuizData(data.getQuizResponse);
            if (data.getQuizResponse?.answers?.birthday_question?.value) {
                setValue(data.getQuizResponse?.answers?.birthday_question?.value);
            } else {
                setValue(dayjs('2000-01-01'));
            }
        },
    });

    const createAnswer = (input: {
        questionId: String;
        questionSubject: String;
        contextType: String;
        contextId: String;
        value: String;
        valueType: String;
        isSkipped?: boolean;
    }) => {
        const variables = {
            input,
        };
        answerMutation({ variables });
    };
    const [answerMutation, { loading: loadingAnswer }] = useMutation(CREATE_ANSWER, {
        onCompleted(response) {
            onAnswerCompleted(response);
        },
        onError(error) {
            console.log('Create Failed: ', error);
        },
    });
    const [getUserByUserName, { loading: userLoading }] = useLazyQuery(GET_USER_BY_USERNAME, {
        onCompleted(data) {
            getQuizResponse({
                variables: {
                    input: {
                        quizId: EQuizId.MY_BIRTHDAY_QUIZ,
                        contextType: quizContextType,
                        contextId: EQuizId.MY_BIRTHDAY_QUIZ,
                        userId: data.getUserByUserName?.id,
                    },
                },
            });
        },
    });
    useEffect(() => {
        if (userName) {
            getUserByUserName({
                variables: {
                    input: {
                        userName,
                    },
                },
            });
        }
    }, [userName, getUserByUserName]);

    useEffect(() => {
        if (currentUser || gender) {
            getQuizResponse({
                variables: {
                    input: {
                        quizId: EQuizId.MY_BIRTHDAY_QUIZ,
                        contextType: quizContextType,
                        contextId: EQuizId.MY_BIRTHDAY_QUIZ,
                        userId: currentUser.uid || gender?.id,
                    },
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser.uid, gender]);

    const onAnswerCompleted = async (response: any) => {
        await getQuizResponse({
            variables: {
                input: {
                    quizId: EQuizId.MY_BIRTHDAY_QUIZ,
                    contextType: quizContextType,
                    contextId: EQuizId.MY_BIRTHDAY_QUIZ,
                    userId: currentUser.uid,
                },
            },
        });
        dispatch(setMyBirthday(response.createAnswer.value));
        location.pathname === PATH.MY_BIRTHDAY_QUIZ
            ? history.push(PATH.PROFILE)
            : history.push(`${PATH.QUIZ_MANAGER}/?signup=${Date.now()}`);
    };
    const input = {
        questionId: EQuestionId.MY_BIRTHDAY,
        questionSubject: '',
        contextType: quizContextType,
        contextId: EQuizId.MY_BIRTHDAY_QUIZ,
        valueType: 'STRING',
    };
    const handleClickAnswer = () => {
        if (Boolean(!userName)) {
            if (value) {
                createAnswer({ ...input, value: dayjs(value).format('MM/DD/YYYY') });
            } else {
                setError('This field is required');
                setValue(null);
            }
        }
    };
    const handleSkip = () => {
        if (Boolean(!userName)) {
            createAnswer({ ...input, value: '', isSkipped: true });
        }
    };
    useSpinnerLoading('loadingQuiz', loadingQuiz);
    useSpinnerLoading('consumer', userLoading);
    return (
        <CustomizeLayoutQuiz
            quizId={EQuizId.MY_BIRTHDAY_QUIZ}
            title={Boolean(!userName) ? quizData?.subTitle : ''}
            titlePage={Boolean(!userName) ? quizData?.title : 'Birthday'}
            handleAnswer={handleClickAnswer}
            isUpdate={location.pathname === PATH.MY_BIRTHDAY_QUIZ}
            isDisplayContent={Boolean(!userName)}
            hideBottomNav={location.pathname !== PATH.MY_BIRTHDAY_QUIZ}
            requiredQuestion={requiredQuestion}
            handleSkipQuestion={handleSkip}
            loading={loadingAnswer}
            nextBtnDisabled={!value}
        >
            <Box textAlign={'center'} width={'100%'} height={'100%'} pt={3}>
                <Box width={'100%'} maxWidth="350px" margin="0 auto" padding="50px 12px">
                    <CustomeDatePicker
                        value={value}
                        setValue={setValue}
                        error={error}
                        setError={setError}
                        isDisabled={false}
                    />
                </Box>
            </Box>
        </CustomizeLayoutQuiz>
    );
}
